import React from 'react';
import { FaCrown } from 'react-icons/fa';
import ComingSoon from './ComingSoon';

interface PricingProps {
  onPlanChange?: (plan: 'free' | 'premium') => void;
}

const Pricing: React.FC<PricingProps> = ({ onPlanChange: _onPlanChange }) => {
  return (
    <ComingSoon
      title="プラン機能"
      description="フリープランとプレミアムプランを選択できる機能を準備中です。現在はすべての機能を無料でご利用いただけます。"
      icon={FaCrown}
      features={[
        "フリープラン（基本機能）",
        "プレミアムプラン（全機能 + 優先サポート）",
        "柔軟な課金システム",
        "使用量ベースの料金設定",
        "カスタムプランオプション"
      ]}
    />
  );
};

export default Pricing;